const clickOutSide = {}

clickOutSide.install = (Vue) => {
    Vue.directive('click-outside', {
        bind(el, binding, vnode) {
            el.__ClickOutsideHandler__ = function (event) {
                // 如果点击的区域是指令绑定的元素内部，直接返回
                if (el.contains(event.target)) {
                    return
                }
                // 否则，执行绑定的回调函数
                if (binding.expression) {
                    binding.value(event)
                }
            }
            // 监听全局的点击事件
            document.addEventListener('click', el.__ClickOutsideHandler__)
        },
        unbind(el) {
            // 移除全局的点击事件监听器
            document.removeEventListener('click', el.__ClickOutsideHandler__)
            el.__ClickOutsideHandler__ = null
        }
    })
}

export default clickOutSide